import React from "react";
import { useTranslation } from "react-i18next";

export const AppFooter = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer-content">
        <div>
          {/*<a href="mailto:info@predsense.ai" className="footer-email">*/}
          {/*  info@predsense.ai*/}
          {/*</a>*/}
          &copy; 2026 Predsense
        </div>
        <div className="footer-right">
          <a href="/llm-info" className="footer-link">
            {t("LlmInfoLink")}
          </a>
          <a href="/impressum" className="footer-link">
            {t("Impressum")}
          </a>
          <a href="/privacy-policy" className="footer-link">
            {t("Datenschutz")}
          </a>
        </div>
      </div>
    </footer>
  );
};
